
export default {
  props: {
    color: String
  },
  setup(props: object) {
    return { ...(props as { color?: string }) };
  }
};
